<template>
    <div
        v-if="title"
        :class="[
            'p-d-flex',
            'p-jc-between',
            'p-ai-center',
            { 'page-content-title': isPageContentTitle },
            { 'page-title': !isPageContentTitle }
        ]"
    >
        <div>
            <span v-if="isPageContentTitle">
                {{ title }}
            </span>
            <h6 v-else>
                {{ title }}
            </h6>
        </div>
        <div>
            <slot />
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';

export default {
    props: ['customTitle', 'isPageContentTitle'],
    setup(props) {
        const title = computed(() => props.customTitle);

        return { title };
    }
};
</script>

<style lang="scss" scoped>
.page-title {
    height: 72px;

    h6 {
        margin: 0px;
    }
}

.page-content-title {
    height: 1.5rem;
    margin: auto;
    font-weight: 700;
    font-size: 1.25rem;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
}
</style>
